import { getProfileData } from '../../backend-api';
import { API_REQUEST } from '../../store/sagas/api';
import { LOAD_CURRENT_USER, LOAD_CURRENT_USER_FAILED, LOAD_CURRENT_USER_SUCCESS } from './action-types';

export const loadCurrentUser = () => ({
  type: API_REQUEST,
  types: [LOAD_CURRENT_USER, LOAD_CURRENT_USER_SUCCESS, LOAD_CURRENT_USER_FAILED],
  call: () => getProfileData(),
});
